import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { StudentChargeHistoryPage } from '~pages/payments/student-charge-history/index';

const schema = z.object({
  id: z.string().regex(/^^(?!\s*$).+/),
});

export const Route = createFileRoute(
  '/_auth/_layout/payment/student-charge-history',
)({
  validateSearch: zodValidator(schema),
  component: StudentChargeHistoryPage,
});
